import { gql } from "@apollo/client";

export const updateKeywordGroupsStatus = gql`
  mutation UpdateKeywordGroupsStatus($input: KeywordGroupStatusBatchUpdateInput!) {
    updateKeywordGroupsStatus(input: $input) {
      success
      code
      message
      updatedCount
    }
  }
`;
